import { useOutletContext, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import spinnerIcon from './/./../assets/img/loadingSpinner.gif'
import SpinnerComponent from '../components/progressbar/SpinnerComponent.js'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faBuilding, faGear, faContactBook, faXmark, faArrowRight, faLink, faFileLines, faFileArrowUp, faFileCode, faUsersGear, faFileArrowDown } from '@fortawesome/free-solid-svg-icons'
import { useAuth0 } from "@auth0/auth0-react";
//import RequestInfoDialog from '../components/request-info/RequestInfo'
import styles from '../styles/Home.module.css'
import happyHolidays from './/./../assets/img/Temp_HappyHolidays_2024.jpeg'

import { MembershipPlansHomeUpgradePrompt } from "../components/membership/MembershipPlans-HomeUpgradePrompt.js";
import { fetchMembershipSubscriptionState, computeSubscriptionStatus } from "../components/membership/MembershipPlans-SubscriptionStatus.js";

//import Cables from './../assets/brand/cables.png';
import Cables from './../assets/brand/pumpjack.png';
import Account from "./Account";
const imgStyle = {
    width: '100%',
    height: 'auto',
    borderRadius: '20px'
};
const imgPublicStyle = {
    width: '100%',
    height: 'auto',
    padding: '0px',
    margin: '0px',
    marginBottom: '0px',
    marginTop: '-24px',
    objectFit: 'fill',
    opacity: '0.75'
};

const Home = props => {

    //properties
    const baseUrl = process.env.REACT_APP_API_BASEURL;

    //stateful properties (hooks)
    const [currentAccount, accountProfile, setAccountProfile, toggleIsShowSidebarMd, setIsShowSidebarMd] = useOutletContext();
    const navigate = useNavigate();
    const { isAuthenticated, isLoading, loginWithRedirect, getAccessTokenSilently } = useAuth0();

    const [pageStatus, setPageStatus] = useState('ready');
    const [dataStatus, setDataStatus] = useState('loading');
    const [pageErrors, setPageErrors] = useState('');
    const [dataErrors, setDataErrors] = useState('');


    const location = useLocation();
    const [queryParameters] = useSearchParams();

    const persistedAccountProfile = (() => {
        try {
            return JSON.parse(localStorage.getItem("accountProfile") ?? "null");
        } catch {
            return null;
        }
    })();

    const effectiveAccountProfile = accountProfile ?? persistedAccountProfile ?? null;

    const [subscriptionsLoading, setSubscriptionsLoading] = useState(false);
    const [subscriptionsLoadFailed, setSubscriptionsLoadFailed] = useState(false);
    const [hasValidSubscriptionStatusResponse, setHasValidSubscriptionStatusResponse] = useState(false);

    const [subscriptionStatus, setSubscriptionStatus] = useState(() =>
        computeSubscriptionStatus({ subscriptionRows: null, accountProfile: effectiveAccountProfile })
    );

    useEffect(() => {
        let isCancelled = false;

        const resolvedAccountId = Number(currentAccount?.id ?? 0);

        const loadSubscriptionRows = async () => {
            setHasValidSubscriptionStatusResponse(false);
            setSubscriptionStatus(computeSubscriptionStatus({ subscriptionRows: null, accountProfile: effectiveAccountProfile }));

            if (!isAuthenticated || !resolvedAccountId || !getAccessTokenSilently) return;

            setSubscriptionsLoading(true);
            setSubscriptionsLoadFailed(false);

            try {
                const result = await fetchMembershipSubscriptionState({
                    accountId: resolvedAccountId,
                    currentAccount,
                    accountProfile: effectiveAccountProfile,
                    getAccessTokenSilently,
                    includeCancelable: false,
                    baseUrl,
                });

                if (isCancelled) return;

                setSubscriptionStatus(result.subscriptionStatus ?? computeSubscriptionStatus({ subscriptionRows: [], accountProfile: effectiveAccountProfile }));
                setSubscriptionsLoading(false);
                setSubscriptionsLoadFailed(Boolean(result.subscriptionsLoadFailed));
                setHasValidSubscriptionStatusResponse(!result.subscriptionsLoadFailed);
            } catch (e) {
                if (isCancelled) return;

                setSubscriptionStatus(computeSubscriptionStatus({ subscriptionRows: null, accountProfile: effectiveAccountProfile }));
                setSubscriptionsLoading(false);
                setSubscriptionsLoadFailed(true);
                setHasValidSubscriptionStatusResponse(false);
            }
        };

        loadSubscriptionRows();

        return () => {
            isCancelled = true;
        };
    }, [isAuthenticated, currentAccount?.id, getAccessTokenSilently, effectiveAccountProfile, currentAccount, baseUrl]);

    const viewerCanManageMembershipUi = Boolean(
        effectiveAccountProfile?.isAdmin ||
        effectiveAccountProfile?.hasImpersonate ||
        false
    );

    const POST_CHECKOUT_RETURN_STORAGE_KEY = "totdata_post_checkout_return";
    const CHECKOUT_FLOW_STORAGE_KEY = "totdata_checkout_flow"; // "legacy" | "new"

    const isSafeSpaPath = (value) => {
        const textValue = String(value || "").trim();
        if (!textValue.startsWith("/")) return false;
        if (textValue.startsWith("//") || /^\w+:\/\//i.test(textValue)) return false;
        return true;
    };

    const handleLogin = async () => {
        console.log(location.pathname);
        await loginWithRedirect({
            appState: {
                //returnTo: window.location.origin,
                //returnTo: location.pathname,
                returnTo: '/'
            },
        });
    };

    //initialize page
    useEffect(() => {
        (async () => {

            if (isAuthenticated) {
                let sessionNonce = null;
                let docId = null;

                //get sessionData from local storage
                const sessionData = localStorage.getItem('sessionData');
                console.log('Session Data: ' + sessionData);
                if (sessionData) {
                    const sessionDataObject = JSON.parse(sessionData);

                    //check sessionData for docId
                    sessionNonce = sessionDataObject.nonce;
                    docId = sessionDataObject.docId;
                    console.log('Session Data Objects - Nonce: ' + sessionNonce + ', DocId: ' + docId);

                    //reset sessionData items in local storage (note: may use for items that we don't want to discard after one use later)
                    const resetSessionData = { nonce: null, docId: null };
                    const resetSessionDataString = JSON.stringify(resetSessionData);
                    localStorage.setItem('sessionData', resetSessionDataString);
                }

                //validate nonce if logging in (ie. exists in local storage)
                var authNonce = location.state;
                if (sessionNonce !== null) {
                    console.log('Post-Auth Nonce: ' + authNonce);

                    if (authNonce != sessionNonce) {
                        //there's a problem; possibly a CSFR, so handle
                        console.log('Warning: Nonce Invalid');
                    }
                    else {
                        console.log('Nonce Validated');
                    }
                }

                if (docId == null) {
                    //check queryParams for docId
                    docId = queryParameters.get("docid");
                    console.log('DocId from Query Param: ' + docId);
                }

                if (docId != null) {
                    //redirect to download page
                    navigate('/download', { state: docId });
                }

                const checkoutSessionId = queryParameters.get("session_id");
                if (checkoutSessionId != null) {
                    const flowParam = String(queryParameters.get("flow") || "").trim().toLowerCase();
                    const storedFlow = String(sessionStorage.getItem(CHECKOUT_FLOW_STORAGE_KEY) || "").trim().toLowerCase();
                    const returnPathFromQuery = String(queryParameters.get("returnPath") || "").trim();
                    const returnPathFromStorage = String(sessionStorage.getItem(POST_CHECKOUT_RETURN_STORAGE_KEY) || "").trim();

                    const hasExplicitRoutingSignal = Boolean(flowParam) || Boolean(storedFlow) || Boolean(returnPathFromQuery) || Boolean(returnPathFromStorage);

                    const isNewFlow = flowParam === "new" || storedFlow === "new";

                    sessionStorage.removeItem(CHECKOUT_FLOW_STORAGE_KEY);
                    sessionStorage.removeItem(POST_CHECKOUT_RETURN_STORAGE_KEY);

                    const destination = isSafeSpaPath(returnPathFromQuery)
                        ? returnPathFromQuery
                        : isSafeSpaPath(returnPathFromStorage)
                            ? returnPathFromStorage
                            : hasExplicitRoutingSignal && isNewFlow
                                ? "/membership-plans"
                                : "/membership";

                    navigate(destination, { replace: true, state: { checkoutSessionId: checkoutSessionId, flow: isNewFlow ? "new" : "legacy" } });
                    //alert('CheckoutSessionId: ' + checkoutSessionId);
                }

                //const adminDashboardParam = queryParameters.get("admindashboard");
                const adminDashboardParam = localStorage.getItem('admindashboard');
                localStorage.removeItem('admindashboard');
                if (adminDashboardParam != null) {
                    navigate('/admindashboard');
                    //alert('CheckoutSessionId: ' + checkoutSessionId);
                }

            }
            else {
                //if registering, short-circuit and navigate to register page without authenticating
                const isRegister = queryParameters.get("register");
                const isDashboard = queryParameters.get("admindashboard");
                if (isRegister !== null) {
                    const numMonthsParam = queryParameters.get("months");

                    let numMonths = 3;
                    if (parseInt(numMonthsParam)) {
                        numMonths = parseInt(numMonthsParam);
                    }

                    //navigate('/register');
                    navigate('/register', { state: numMonths });
                }
                else if (isDashboard !== null) {

                    //navigate('/register');
                    navigate('/admindashboard');
                }
                else {
                    //create a one-time state identifier (nonce)
                    const nonce = uuidv4();

                    //if downloading document, save the docId in local storage for retrieval on authentication callback
                    let docId = queryParameters.get("docid");
                    //docId = 'my docId'

                    //save sessionData in local storage
                    const sessionData = { nonce: nonce, docId: docId };
                    const sessionDataString = JSON.stringify(sessionData);
                    localStorage.setItem('sessionData', sessionDataString);

                    //navigate to signin page (pass nonce in state)
                    navigate('/signin', { state: nonce });
                }
            }

            //console.log('Initializing page...');
            if (setIsShowSidebarMd) {
                setIsShowSidebarMd(true);
            }

        })();
    }, []);

    const uuidv4 = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
            .replace(/[xy]/g, function(c) {
                const r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
    }

    //render profile overview info
    const cardNavigate = (path) => {

        if (path == '/') {
            toggleIsShowSidebarMd();
        }
        else {
            navigate(path);
        }
    }

    const sectionLabel = (text) => (
        <p style={{ fontSize: '0.72rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '.08em', color: '#6b7280', marginBottom: '10px' }}>{text}</p>
    );

    //render cards
    const showCards = () => {
        const isOperator = accountProfile.accountType === "Admin" || accountProfile.accountType === "Sender" || accountProfile.accountType === "SenderReceiver";
        const hasDocConversion = accountProfile.hasDocConversion;

        if (isOperator) {
            return (
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={10} md={4}>
                            {sectionLabel('Operated')}
                            {showDataFiles()}
                            {showOwnerMapping()}
                            {showImport()}
                            {hasDocConversion && showDocumentConverter()}
                        </Col>
                        <Col xs={0} className="d-none d-md-block" style={{ flex: '0 0 2.08%', maxWidth: '2.08%' }} />
                        <Col xs={10} md={4}>
                            {sectionLabel('Non-Operated')}
                            {showCheckStatements()}
                            {showMyOperators()}
                            {showDocumentConverter()}
                        </Col>
                    </Row>
                </Container>
            );
        }

        return (
            <Container>
                <Row className="justify-content-center">
                    <Col xs={10} sm={8} md={6} lg={5} xl={4}>
                        {showCheckStatements()}
                        {showMyOperators()}
                        {showDocumentConverter()}
                    </Col>
                </Row>
            </Container>
        );
    }

    const homeCard = (path, icon, label, description, barColor) => (
        <Card className="mb-3" style={{ cursor: 'pointer', background: '#ffffff', border: '1px solid #e5e7eb', borderLeft: `3px solid ${barColor}`, borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,.08)', transition: 'transform 150ms ease, box-shadow 150ms ease' }}
            onClick={() => cardNavigate(path)}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.14)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,.08)'; }}
        >
            <Card.Header style={{ background: 'transparent', border: 'none', padding: '14px 16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div style={{ width: '38px', height: '38px', borderRadius: '9px', background: '#f3f4f6', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <FontAwesomeIcon icon={icon} style={{ width: '16px', height: '16px', color: barColor }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '0.82rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '.06em', color: '#1f2937', lineHeight: '1.2' }}>{label}</div>
                        <div style={{ fontSize: '0.78rem', color: '#6b7280', marginTop: '3px', fontWeight: '500', lineHeight: '1.3' }}>{description}</div>
                    </div>
                    <FontAwesomeIcon icon={faArrowRight} style={{ width: '13px', color: '#9ca3af', flexShrink: 0 }} />
                </div>
            </Card.Header>
        </Card>
    );

    const showImport = () => homeCard('/import', faFileArrowUp, 'Import Files', 'Upload and process operator data files', '#5B9BD5');
    const showDataFiles = () => homeCard('/datafiles', faFileLines, 'Manage Statements', 'View, organize, and publish statement data', '#5B9BD5');
    const showOwnerMapping = () => homeCard('/mappedowners', faUsersGear, 'Manage my Owners', 'Map and manage owner relationships', '#C8B568');
    const showCheckStatements = () => homeCard('/checkfiles', faFileArrowDown, 'Access my Statements', 'Download your revenue and JIB statements', '#5B9BD5');
    const showMyOperators = () => homeCard('/sendingoperators', faBuilding, 'Manage my Operators', 'View and update your operator connections', '#C8B568');
    const showDocumentConverter = () => homeCard('/documentconversion', faFileCode, 'Convert my Documents', 'Transform documents to standard formats', '#5B9BD5');

    //render page loading
    //note: spinner overlay will eventually be at the page level (I think)
    const showPageLoading = () => {
        return (
            <div>
                <SpinnerComponent />
            </div>
        );
    }

    //render page loading
    const showDataLoading = () => {
        return (
            <Row>
                <SpinnerComponent />
            </Row>
        );
    }

    //render page error
    const showPageError = () => {
        return (
            <div>
                Oops, there was a page load error: {pageErrors}
            </div>
        );
    }

    //render data error
    const showDataError = () => {
        return (
            <Row>
                Oops, there was a data load error: {dataErrors}
            </Row>
        );
    }

    return (
        <>
            {(() => {
                if (isLoading) {
                    return showPageLoading();
                }
                else {
                    if (!isAuthenticated) {
                        return <>
                            <div className={styles.contentSection} />
                            <div className="body flex-grow-1" style={{ marginTop: '-24px' }} >
                            </div>
                            <div style={{
                                position: 'absolute',
                                top: '35%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: '20'
                            }} >
                                <p style={{ fontSize: "2.0em", fontWeight: "bold", margin: "0px 0px 15px 0px" }} >THE OPERATORS DATA PLATFORM</p>
                                <p style={{ fontSize: "1.5em", fontWeight: "bold", margin: "0px" }} >Changing the way owner data is delivered.</p>
                                <div style={{ textAlign: "center", marginTop: "30px" }} >
                                    {/*<RequestInfoDialog />*/}
                                </div>
                            </div>
                        </>
                    }
                    else {
                        return <>
                            <br /><br />
                            {(() => {
                                if (false) {
                                    return <Container>
                                        <Row>
                                            <Col xs={8} style={{ marginLeft: '-12px' }} >
                                                <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1a1a1a', marginBottom: '4px' }}>Welcome, {(accountProfile.firstName ?? '') === '' ? accountProfile.nickname : accountProfile.firstName}!</p>
                                                <p className="display-6" style={{ marginTop: '50px' }} >What would you like to do today?</p>
                                            </Col>
                                            <Col xs={4}>
                                                <Container>
                                                    <Card className="mb-4 shadow" style={{ margin: '0px', padding: '0px', marginTop: '-50px' }} >
                                                        <Card.Body style={{ margin: '0px', padding: '8px' }}>
                                                            <Row>
                                                                <Col className="d-flex justify-content-center">
                                                                    <img src={happyHolidays} alt="Holiday Special" style={{ width: '75%', height: 'auto' }} />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col className="d-flex justify-content-center">
                                                                    <Button size="sm"
                                                                        onClick={() => navigate('/membership')}
                                                                        style={{
                                                                            width: '280px',
                                                                            border: '1px solid #C8B568',
                                                                            borderRadius: '20px',
                                                                            backgroundColor: '#C8B568',
                                                                            color: '#fff',
                                                                            fontSize: '.85rem',
                                                                            fontWeight: '600',
                                                                            marginTop: '10px'
                                                                        }} >
                                                                        Click Here to Upgrade Membership!
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </Container>
                                            </Col>
                                        </Row>
                                    </Container>
                                } else {
                                    return <>
                                        <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', marginBottom: '4px', textAlign: 'center' }}>Welcome, {(accountProfile.firstName ?? '') === '' ? accountProfile.nickname : accountProfile.firstName}!</p>

                                        {/*{hasValidSubscriptionStatusResponse && !subscriptionsLoading && !subscriptionsLoadFailed && subscriptionStatus ? <MembershipPlansHomeUpgradePrompt subscriptionStatus={subscriptionStatus} accountTypeId={Number(effectiveAccountProfile?.accountTypeId ?? currentAccount?.accountTypeId ?? 0)} baseUrl={baseUrl} /> : null}*/}
                                    </>
                                }
                            })()}

                            <div className="body flex-grow-1 px-3" style={{ marginTop: (false ? '-60px' : '0px') }} >
                                {(() => {
                                    if (false) {
                                        return <Container fluid="lg">
                                            {/*<Row style={{ height: "25px" }} ></Row>*/}
                                            {/*<Row style={{ marginBottom: '30px' }} >*/}
                                            {/*    <p className="display-6">What would you like to do today?</p>*/}
                                            {/*</Row>*/}
                                            <Row style={{ marginTop: '20px' }} >
                                                {showCards()}
                                            </Row>
                                        </Container>
                                    } else {
                                        return <Container fluid="lg">
                                            <Row style={{ height: "25px" }} ></Row>
                                            <Row className="justify-content-center" style={{ marginBottom: '30px' }} >
                                                <p style={{ fontSize: '1.15rem', fontWeight: '500', color: '#6b7280', margin: 0, textAlign: 'center' }}>What would you like to do today?</p>
                                            </Row>
                                            <Row style={{ marginTop: '20px' }} >
                                                {showCards()}
                                            </Row>
                                        </Container>
                                    }
                                })()}
                            </div>
                        </>
                    }
                }
            })()}
        </>
    );
}

export default Home;